// extracted by mini-css-extract-plugin
export var PaginationButton = "index-module--PaginationButton--QfGvz";
export var addressContainer = "index-module--addressContainer--QK7pa";
export var buttonIcon = "index-module--buttonIcon--29KgC";
export var logoContainer = "index-module--logoContainer--9CV46";
export var nextButton = "index-module--nextButton--dDPnA";
export var prevButton = "index-module--prevButton---ciaB";
export var reviewSlideContainer = "index-module--reviewSlideContainer--qtoRJ";
export var slide = "index-module--slide--9Q2rS";